import { BaseApi } from "./baseService";
import { Http, RequestOptions } from "@angular/http";
import { ConfigService } from "./configService";
import { Injectable } from "@angular/core";
import { BaseResponse } from "../objects/common/baseResponse";
import { App } from "../objects/apps/app";
import { InstallAppResponse } from "../objects/apps/installAppResponse";
import { User } from "../objects/users/user";
import { OrderSubscriptionRequest, Subscription } from "../objects/subscriptions/subscription";
import { PaymentResponse } from "../objects/subscriptions/paymentResponse";

@Injectable()
export class AppService extends BaseApi {

    constructor(http: Http, configService: ConfigService) {
        super(http, configService);
    }

    public getAllApps(): Promise<BaseResponse<Array<App>>> {
        return this.get(new RequestOptions({
            url: `v2/apps/all`
        }));
    }

    public getApp(appId: number): Promise<BaseResponse<App>> {
        return this.get(new RequestOptions({
            url: `v2/apps/${appId}`
        }));
    }

    public getUsers(appId: number, groupId: Array<number>): Promise<BaseResponse<Array<User>>> {
        return this.get(new RequestOptions({
            url: `v2/apps/${appId}/groups/users`,
            params: { groupId: groupId }
        }));
    }

    public updateApp(app: App): Promise<BaseResponse<App>> {
        return this.put(new RequestOptions({
            url: `v2/apps/${app.Id}`,
            body: JSON.stringify(app)
        }));
    }

    public updateAppGroups(app: App): Promise<BaseResponse<App>> {
        return this.put(new RequestOptions({
            url: `v2/apps/${app.Id}/groups`,
            body: JSON.stringify(app)
        }));
    }

    public installApp(app: App): Promise<BaseResponse<InstallAppResponse>> {
        return this.post(new RequestOptions({
            url: `v2/apps`,
            body: app
        }));
    }

    public getCurrentSubscription(appId: number): Promise<BaseResponse<Subscription>> {
        return this.get(new RequestOptions({
            url: `v2/apps/${appId}/subscriptions`
        }));
    }

    public orderSubscription(appId: number, request: OrderSubscriptionRequest): Promise<BaseResponse<PaymentResponse>> {
        return this.post(new RequestOptions({
            url: `v2/apps/${appId}/subscriptions`,
            body: request
        }));
    }
}


// WEBPACK FOOTER //
// ./app/services/appService.ts